// Per unit discount at this sell price: a percentage is rounded to the cent, else the fixed amount
const unitDiscount = (sellPrice, discountPercentage, discountAmount) => discountPercentage != null
  ? Math.round(sellPrice * discountPercentage) / 100
  : Number(discountAmount) || 0

module.exports = { unitDiscount }
